module.exports = __webpack_public_path__ + "static/media/productfeaturediversity.6a605764.png";